var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "#222",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0833 14.6666H11.9167V6.41665H14.6667L11 1.83331L7.33334 6.41665H10.0833V14.6666Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58333 20.1667H17.4167C18.4278 20.1667 19.25 19.3444 19.25 18.3333V10.0833C19.25 9.07225 18.4278 8.25 17.4167 8.25H13.75V10.0833H17.4167V18.3333H4.58333V10.0833H8.25V8.25H4.58333C3.57225 8.25 2.75 9.07225 2.75 10.0833V18.3333C2.75 19.3444 3.57225 20.1667 4.58333 20.1667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.11417de9c88b120cfe65e9a1aa2d35de.svg";
export { ForwardRef as ReactComponent };